<template>
  <v-row id="dropdowns">
    <v-col cols="12" sm="4" md="4" id="project">
      <v-select :items="projects" item-text="Name" item-value="Id" :label="$t('common.projectName')" v-model="selProjectId" @change="filterByProject()" @click:clear="clearProject()" clearable></v-select>
    </v-col>
    <v-col cols="12" sm="4" md="4" id="asset">
      <v-select :items="vessels" item-text="Name" item-value="Id" :label="$t('common.asset')" v-model="selVesselId" @change="filterByVessel()" clearable></v-select>
    </v-col>
  </v-row>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import Vue from "vue";

export default {
  data() {
    return {
      selProjectId: 0,
      selVesselId: 0,
    };
  },
  computed: {
    ...mapGetters(["m_project/getProjectNames", "m_vessel/getVesselNames", "m_passet/getSelProjectId", "m_passet/getSelVesselId", "m_passet/getSelProjectVesselIds"]),
    projects() {
      return this["m_project/getProjectNames"];
    },
    vessels() {
      let vessels = this["m_vessel/getVesselNames"];
      let pvIds = this["m_passet/getSelProjectVesselIds"];
      return vessels.filter((v) => pvIds.indexOf(v.Id) != -1);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapActions(["m_project/fetchProjectNames", "m_vessel/fetchVesselNames", "m_passet/fetchProjectVesselNames"]),
    ...mapMutations(["m_passet/SET_SEL_PROJECT_ID", "m_passet/SET_SEL_VESSEL_ID"]),

    clearProject() {
      this.$log.debug("project was cleared");
      this.selProjectId = null;
      this.filterByProject();

      this.selVesselId = null;
      this.filterByVessel();
    },

    filterByProject() {
      this["m_passet/SET_SEL_PROJECT_ID"](this.selProjectId);
      this.$emit("project-changed", this.selProjectId);

      Vue.$log.debug("load and filter vessels by project", this.selProjectId);
      this["m_passet/fetchProjectVesselNames"](this.selProjectId);
    },

    filterByVessel() {
      this["m_passet/SET_SEL_VESSEL_ID"](this.selVesselId);
      this.$emit("vessel-changed", this.selVesselId);
    },
  },

  watch: {
    selProjectId: function() {
      if (this.selProjectId && this.selVesselId) this.$emit("set-date", this.selProjectId, this.selVesselId);
    },

    selVesselId: function() {
      if (this.selProjectId && this.selVesselId) this.$emit("set-date", this.selProjectId, this.selVesselId);
    },
  },

  created() {
    Vue.$log.debug("loading default data ...");
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this["m_project/fetchProjectNames"]();
    this["m_vessel/fetchVesselNames"]();
  },
};
</script>
<style>
#dropdowns {
  margin-bottom: 20px;
}
</style>
